import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyCC9Kx801-ho54L7i3-XJuA-JnUWuAzjDw",
    authDomain: "coconoot-e7b10.firebaseapp.com",
    projectId: "coconoot-e7b10",
    storageBucket: "coconoot-e7b10.appspot.com",
    messagingSenderId: "540674231151",
    appId: "1:540674231151:web:420b75d9bf350a3e43f69a",
    measurementId: "G-209079LN73"
  });

  const db = firebase.firestore();
  const auth = firebase.auth();
  const storage = firebase.storage();
  const functions = firebase.functions();
  
  export {db, auth, storage, functions};